import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Alert, Box } from '@mui/material';
import { t } from '../../utils/textUtils';

/**
 * Componente para proteger rutas exclusivas para usuarios con rol comercial
 * @param {React.ReactNode} children - Componentes hijos a renderizar si el usuario está autorizado
 * @param {boolean} redirectToDashboard - Si es true, redirige al dashboard en caso de acceso no autorizado
 */
const CommercialRoute = ({ children, redirectToDashboard = true }) => {
  const { user, isAuthenticated } = useAuth();
  
  // Verificar si el usuario está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Verificar si el usuario tiene rol comercial (manager o staff)
  const isCommercial = user && ['commercial_manager', 'commercial_staff'].includes(user.role);
  const isAdmin = user && (user.role === 'admin' || user.role === 'Director' || user.role === 'director');
  
  // También permitir acceso a administradores
  if (!isCommercial && !isAdmin) {
    console.log('Access denied: User is not commercial or admin');
    
    if (redirectToDashboard) {
      return <Navigate to="/dashboard" replace />;
    } else {
      return (
        <Box sx={{ p: 3 }}>
          <Alert severity="error">
            {t('ANDA TIDAK MEMILIKI IZIN UNTUK MENGAKSES HALAMAN INI. HALAMAN INI EKSKLUSIF UNTUK PENGGUNA DENGAN PERAN KOMERSIAL.')}
          </Alert>
        </Box>
      );
    }
  }
  
  return children;
};

export default CommercialRoute; 